module.exports = __webpack_public_path__ + "img/handIconFSFB.5049379b.svg";